import { createAction, props } from '@ngrx/store';
import { OxErrorResponse } from 'src/app/core/interfaces';
import {
  AcceptInvitationParams,
  AdminAccount,
  GetAccountResponse,
  OxioPermissions,
} from '../../proto/consulate';

interface ActionAdminAccount {
  adminAccount: AdminAccount;
  isOxioAdmin: boolean;
  permissions?: OxioPermissions;
}
export const login = createAction(
  '[Login Page] AdminAccount Authorize Attempt',
  props<{ email: string; password: string }>()
);

export const loginSuccess = createAction(
  '[Auth API] AdminAccount Authorized Successfully',
  props<ActionAdminAccount>()
);

export const loginFailure = createAction(
  '[Auth API] AdminAccount Authorization Error',
  props<{ error: OxErrorResponse }>()
);

export const getAccount = createAction('[App Component] Get Account');

export const getAccountSuccess = createAction(
  '[Accounts API] Get Account Success',
  props<{
    adminAccount: AdminAccount & GetAccountResponse;
    isOxioAdmin: boolean;
    permissions?: OxioPermissions;
  }>()
);

export const getAccountFailure = createAction(
  '[App Component] Get Account Authorize'
);

export const purge = createAction(
  '[Purge AdminAccount Effect] AdminAccount Purge Attempt'
);

export const purged = createAction(
  '[Purge AdminAccount Effect] AdminAccount Purged Successfully'
);

export const logout = createAction('[Top Menu] Logout');

export const logoutSuccessful = createAction(
  '[Logout Effect] Logout Successful'
);

export const acceptInvitation = createAction(
  '[Invite Page] Accept Invitation',
  props<{ params: AcceptInvitationParams }>()
);

export const invitationSuccess = createAction(
  '[Accounts API] Invitation Success',
  props<ActionAdminAccount>()
);

export const inviteFailure = createAction(
  '[Accounts API] Invitation Error',
  props<{ error: OxErrorResponse }>()
);

export const addStoredPermission = createAction(
  '[Stored Permissions] Add Stored Permission',
  props<{ [key: string]: boolean }>()
);

export const setOXIOAdmin = createAction(
  '[Accounts API] Set OXIO Admin',
  props<{ isOxioAdmin: boolean }>()
);
